import { useMemo } from "react";

interface IntroSectionTexts {
  title: string;
  heading?: string;
  paragraph1: string;
  paragraph2: string;
  strong_name: string;
}

interface IntroSectionProps {
  texts?: IntroSectionTexts;
}

export default function IntroSection({ texts }: IntroSectionProps) {

  const strongName = texts?.strong_name ?? "";
  const paragraph2Text = texts?.paragraph2 ?? "";
  const p2Parts = useMemo(
    () => paragraph2Text.split(strongName),
    [paragraph2Text, strongName]
  );

  return (
    <section className="py-6 md:py-8 px-4 md:px-6 lg:px-8 bg-white">
      <div className="max-w-5xl mx-auto">
        <p className="font-heading text-lg md:text-xl font-bold text-primary-600 mb-5 md:mb-7">
          {texts ? texts.title : "NetBasis International - linking people & business"}
        </p>

        <div className="space-y-4 text-foreground-950 leading-relaxed text-sm md:text-base">
          {texts?.heading && (
            <h1 className="text-sm md:text-base font-semibold text-foreground-950 mb-4 font-sans">{texts.heading}</h1>
          )}
          <p>{texts ? texts.paragraph1 : ""}</p>
          <p>
            {p2Parts.map((part, i) => (
              <span key={i}>
                {part}
                {i < p2Parts.length - 1 && (
                  <strong className="text-primary-600">{strongName}</strong>
                )}
              </span>
            ))}
          </p>
        </div>
      </div>
    </section>
  );
}